import React, { useState, useEffect } from "react";
import EffortForm1 from "../../forms/EffortForm1";
import EffortForm2 from "../../forms/EffortForm2";
import EffortForm3 from "../../forms/EffortForm3";
import EffortForm4 from "../../forms/EffortForm5/EffortForm5";
import { connect, useSelector } from "react-redux";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import DefaultButton from "../../components/DefaultButton";
import { EffortEncRow } from "../../constants/Effort";
import {
  validateEffortSet1,
  validateEffortSet2,
  validateEffortSet3,
  validateEffortSet4,
} from "../../constants/effortValidations";
import { latLongFormats } from "../../constants/LatLong";
import { getCurrentOpenTrip } from "../../constants/vtrTrip";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import { success } from "../../constants/colors";
import { saveUserSelection } from "../../constants/default_request";
import { useNavigate, useLocation } from "react-router-dom";
import useDisplayLobsterQuestions from "../../constants/useDisplayLobsterQuestions";

function EffortsPage({ actions }) {
  const { auth, vtrTrip, validation, helpText } = useSelector((state) => state);
  const location = useLocation();
  const [report_type, setReportType] = useState("");
  const [maximumStep, setMaximumStep] = useState(3);
  const [currentState, setCurrentState] = useState({
    currentStep: 1,
    maximumStep: maximumStep,
    gearcode: "",
    gearname: "",
    show_mesh_size: false,
    mesh_size_minimum: null,
    mesh_size_maximum: null,
    show_gear_qty: false,
    gear_qty_minimum: null,
    gear_qty_maximum: null,
    show_gear_size: false,
    gear_size_minimum: null,
    gear_size_maximum: null,
    show_number_of_hauls: false,
    number_of_hauls_minimum: null,
    number_of_hauls_maximum: null,
    show_soak_time: false,
    soak_hours_minimum: null,
    soak_hours_maximum: null,
    gearqty: "",
    gearsize: "",
    mesh_size: "",
    lat_long_format: "",
    latitude_or_loran1: {
      decimal_degrees: "",
      degrees_decimal_minutes: { degrees: "", minutes: "" },
      degrees_minutes_seconds: { degrees: "", minutes: "", seconds: "" },
    },
    longitude_or_loran2: {
      decimal_degrees: "",
      degrees_decimal_minutes: { degrees: "", minutes: "" },
      degrees_minutes_seconds: { degrees: "", minutes: "", seconds: "" },
    },
    chart_area: "",
    fishing_depth: "",
    fishing_depth_uom: "fa",
    number_of_hauls: "",
    tow_soak_time: { hours: "", minutes: "" },
    latLongFormats: latLongFormats,
    numTrapsHauled: "",
    numTrapsInWater: "",
    numTrapsPerString: "",
    numBuoyLines: "",
    stringsHauled: "",
    avgSoakTime: "",
    reportType: report_type,
  });
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCurrentState({ ...currentState, [name]: value });
  };

  const _prev = (event) => {
    event.preventDefault();
    let currentStep = currentState.currentStep;
    currentStep = currentStep <= 1 ? 1 : currentStep - 1;
    setCurrentState({ ...currentState, currentStep: currentStep });
  };

  const _next = (event, value) => {
    event.preventDefault();
    const gearValidations = validation.validations.gear;
    window.scrollTo(0, 0);
    let errors1 = [];
    let errors2 = [];
    let errors3 = [];
    let errors4 = [];

    if (currentState.currentStep === 1) {
      errors1 = validateEffortSet1(currentState, gearValidations);
    }
    if (currentState.currentStep === 2) {
      errors2 = validateEffortSet2(currentState, gearValidations);
    }
    if (currentState.currentStep === 3) {
      errors3 = validateEffortSet3(currentState, gearValidations);
    }
    if (currentState.currentStep === 4) {
      errors4 = validateEffortSet4(currentState);
    }
    let allErrors = errors1.concat(errors2, errors3, errors4);
    actions.setError(allErrors);
    if (allErrors.length > 0) {
      return;
    }
    if (currentState.currentStep !== currentState.maximumStep) {
      setCurrentState({
        ...currentState,
        currentStep: currentState.currentStep + 1,
      });
    }

    if (value === "Save") {
      let allOpenTrips = vtrTrip.allOpenTrips;
      let tripId = location.state.trip_id;
      let currentTrip = getCurrentOpenTrip(allOpenTrips, tripId);
      let nrEfforts = 0;
      if (
        currentTrip.images.length > 0 &&
        currentTrip.images[0].hasOwnProperty("gearcode")
      ) {
        nrEfforts = currentTrip.images.length;
      }
      let currentEffort = new EffortEncRow();
      currentEffort.setGearQty(currentState.gearqty);
      currentEffort.setGearSize(currentState.gearsize);
      currentEffort.setNumberOfHauls(currentState.number_of_hauls);
      currentEffort.setGearCode(currentState.gearcode);
      currentEffort.setGearName(currentState.gearname);
      currentEffort.setMeshSize(currentState.mesh_size);
      currentEffort.setSoakTime(
        currentState.tow_soak_time.hours,
        currentState.tow_soak_time.minutes
      );
      currentEffort.setChartArea(currentState.chart_area);
      currentEffort.setFishingDepth(currentState.fishing_depth);
      currentEffort.setLanLongFormat(currentState.lat_long_format);
      currentEffort.setLatitude(currentState.latitude_or_loran1);
      currentEffort.setLongitude(currentState.longitude_or_loran2);
      // * Adding fields values when Lobster report type
      if (
        currentState.reportType === "2" &&
        ["PTLL", "PTCL"].includes(currentState.gearcode)
      ) {
        currentEffort.setNumTrapsInWater(currentState.numTrapsInWater);
        currentEffort.setNumBuoyLines(currentState.numBuoyLines);
        currentEffort.setNumTrapsHauled(currentState.numTrapsHauled);
        currentEffort.setStringsHauled(currentState.stringsHauled);
        currentEffort.setNumTrapsPerString(currentState.numTrapsPerString);
        currentEffort.setAvgSoakTime(currentState.avgSoakTime);
      } else {
        currentEffort.setNumTrapsInWater("");
        currentEffort.setNumBuoyLines("");
        currentEffort.setNumTrapsHauled("");
        currentEffort.setStringsHauled("");
        currentEffort.setNumTrapsPerString("");
        currentEffort.setAvgSoakTime("");
      }
      currentTrip.images[nrEfforts] = currentEffort;
      actions.saveEffort(currentTrip, auth.client_id);
      saveUserSelection(auth.client_id, currentState.lat_long_format);
    }
  };

  const nextButton = () => {
    let currentStep = currentState.currentStep;
    let saveBtn = false;
    if (currentStep === currentState.maximumStep) {
      saveBtn = true;
    }
    if (currentStep <= currentState.maximumStep) {
      return (
        <DefaultButton
          changeHandler={_next}
          buttonText={saveBtn === true ? "Save" : "Next"}
          bgColor={saveBtn === true ? success : ""}
        />
      );
    }
    return null;
  };

  useEffect(() => {
    if (
      currentState.currentStep === currentState.maximumStep &&
      vtrTrip.redirect === true
    ) {
      navigate(`${process.env.PUBLIC_URL}/effort-review`, {
        state: {
          trip_id: location.state.trip_id,
          client_id: auth.client_id,
          effortNr: location.state.newEffortNr,
        },
      });
    }
    if (location.state.currentTrip !== undefined) {
      setReportType(location.state.currentTrip.report_type);
    }
  }, [
    currentState,
    vtrTrip.redirect,
    location.state.currentTrip,
    location.state.trip_id,
    location.state.newEffortNr,
    auth.client_id,
    navigate,
  ]);

  const [
    displayTrapsPerEffortQuestion,
    setDisplayTrapsPerEffortQuestion,
    displayTrapsInWaterQuestion,
    setDisplayTrapsInWaterQuestion,
    displayLinesInWaterQuestion,
    setDisplayLinesInWaterQuestion,
    displayTrapsPerStringQuestion,
    setDisplayTrapsPerStringQuestion,
    displayAllQuestions,
    setDisplayAllQuestions,
    checkTypeAndGear,
    displayStringsHauledPerEffortQuestion,
    setDisplayStringsHauledPerEffortQuestion,
    displayAverageSoakTimePerEffortQuestion,
    setDisplayAverageSoakTimePerEffortQuestion,
  ] = useDisplayLobsterQuestions();

  useEffect(() => {
    if (report_type) {
      const maximumStep =
        report_type !== "2"
          ? 3
          : report_type === "2" && displayAllQuestions === false
          ? 3
          : 4;
      setMaximumStep(maximumStep);
      setCurrentState({
        ...currentState,
        reportType: report_type,
        maximumStep: maximumStep,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [report_type, currentState.gearcode, displayAllQuestions]);

  const gearValidation = validation.validations.gear;
  useEffect(() => {
    const linesInWater = checkTypeAndGear(
      currentState,
      gearValidation,
      "lines_in_water_per_area",
      currentState
    );
    setDisplayLinesInWaterQuestion(linesInWater);

    const trapsInWater = checkTypeAndGear(
      currentState,
      gearValidation,
      "traps_in_water_per_area",
      currentState
    );
    setDisplayTrapsInWaterQuestion(trapsInWater);

    const trapsPerString = checkTypeAndGear(
      currentState,
      gearValidation,
      "traps_per_string_per_area",
      currentState
    );
    setDisplayTrapsPerStringQuestion(trapsPerString);

    const trapsPerEffort = checkTypeAndGear(
      currentState,
      gearValidation,
      "traps_per_effort",
      currentState
    );
    setDisplayTrapsPerEffortQuestion(trapsPerEffort);

    const stringsHauledPerEffort = checkTypeAndGear(
      currentState,
      gearValidation,
      "strings_hauled_per_effort",
      currentState
    );
    setDisplayStringsHauledPerEffortQuestion(stringsHauledPerEffort);

    const averageSoakTimePerEffort = checkTypeAndGear(
      currentState,
      gearValidation,
      "avg_soak_time_per_effort",
      currentState
    );
    setDisplayAverageSoakTimePerEffortQuestion(averageSoakTimePerEffort);

    if (
      displayLinesInWaterQuestion &&
      displayTrapsInWaterQuestion &&
      displayTrapsPerEffortQuestion &&
      displayTrapsPerStringQuestion &&
      displayStringsHauledPerEffortQuestion &&
      displayAverageSoakTimePerEffortQuestion
    ) {
      setDisplayAllQuestions(true);
    } else {
      setDisplayAllQuestions(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentState.gearcode,
    displayAllQuestions,
    displayLinesInWaterQuestion,
    displayTrapsInWaterQuestion,
    displayTrapsPerEffortQuestion,
    displayTrapsPerStringQuestion,
    displayStringsHauledPerEffortQuestion,
    displayAverageSoakTimePerEffortQuestion,
  ]);

  return (
    <form>
      <EffortForm1
        handleChange={handleInputChange}
        gearcode={currentState.gearcode}
        gearname={currentState.gearname}
        gearqty={currentState.gearqty}
        gearsize={currentState.gearsize}
        mesh_size={currentState.mesh_size}
        gearCodeOptions={validation.validations.gear}
        currentStep={currentState.currentStep}
        showGearGty={currentState.show_gear_qty}
        showGearSize={currentState.show_gear_size}
        showMeshSize={currentState.show_mesh_size}
        preferences={auth.vtr_preferences}
        helpText={helpText.helpText}
        reportType={currentState.reportType}
        updateState={setCurrentState}
        currentState={currentState}
      />
      <EffortForm2
        handleChange={handleInputChange}
        gearCodeOptions={validation.validations.gear}
        gearcode={currentState.gearcode}
        chart_area={currentState.chart_area}
        chart_area_options={validation.validations.chartArea}
        showNumberOfHauls={currentState.show_number_of_hauls}
        number_of_hauls={currentState.number_of_hauls}
        showTowSoakTime={currentState.show_soak_time}
        tow_soak_time={currentState.tow_soak_time}
        fishing_depth={currentState.fishing_depth}
        fishing_depth_uom={currentState.fishing_depth_uom}
        currentStep={currentState.currentStep}
        preferences={auth.vtr_preferences}
        helpText={helpText.helpText}
        reportType={currentState.reportType}
        updateState={setCurrentState}
        currentState={currentState}
      />
      <EffortForm3
        currentStep={currentState.currentStep}
        latitude_or_loran1={currentState.latitude_or_loran1}
        longitude_or_loran2={currentState.longitude_or_loran2}
        latLongFormats={currentState.latLongFormats}
        lat_long_format={currentState.lat_long_format}
        helpText={helpText.helpText}
        updateState={setCurrentState}
        currentState={currentState}
      />
      {currentState.reportType === "2" && (
        <EffortForm4
          currentStep={currentState.currentStep}
          numTrapsHauled={currentState.numTrapsHauled}
          numTrapsInWater={currentState.numTrapsInWater}
          numTrapsPerString={currentState.numTrapsPerString}
          numBuoyLines={currentState.numBuoyLines}
          stringsHauled={currentState.stringsHauled}
          avgSoakTime={currentState.avgSoakTime}
          handleChange={handleInputChange}
          displayLinesInWaterQuestion={displayLinesInWaterQuestion}
          displayTrapsInWaterQuestion={displayTrapsInWaterQuestion}
          displayTrapsPerEffortQuestion={displayTrapsPerEffortQuestion}
          displayTrapsPerStringQuestion={displayTrapsPerStringQuestion}
          displayStringsHauledPerEffortQuestion={displayStringsHauledPerEffortQuestion}
          displayAverageSoakTimePerEffortQuestion={
            displayAverageSoakTimePerEffortQuestion
          }
        />
      )}
      <Box mt={5} width="100%" align="center">
        <Grid container justifyContent="center" alignItems="center">
          {currentState.currentStep > 1 && (
            <Grid item xs="auto" className="margRight20">
              <DefaultButton changeHandler={_prev} buttonText={"Back"} />
            </Grid>
          )}
          <Grid item xs="auto">
            {nextButton()}
          </Grid>
        </Grid>
      </Box>
    </form>
  );
}

export default connect(mapVtrStateToProps, mapDispatchToProps)(EffortsPage);
